const getBotResponse = (type) => {
    return BotResponses[type][Math.floor(Math.random() * BotResponses[type].length)];
}

export default getBotResponse;

const BotResponses = {
    "introduction greetings": [
        `I'm AD, I'll be assisting you around here...`, // &#127866;
        `AD here, I'm your AI assitant. Feel free to reach out anytime.`, // &#129309;
        `Thanks for choosing us. I'm AD, your assistant here... 
        I was just checking the flight prices, there's been a drop. , 
        I encourage you to book your flights ASAP.`, // &#128077;
        `Cheers... call me AD, I'm your AI assistant...` // &#128578;
    ],
    "no hotel booking": [
        "We can't book hotels for now",
        "Hotel booking isn't allowed at the moment",
        "No Hotel search can be done for now",
        "We are doing some maintenance work. Hotel booking isn't possible right now"
    ],
    "no cars renting": [
        "Cars search cannot be done today due to site maintenance",
        "You can't search cars today",
        "We are making some fixes in order to enable car rentals. In the meantime try something else",
        "I promise you that we'll work around the clock to enable car rentals soon",
        "IT department are still working on enabling car rentals feature..."
    ],
    "no travel packages": [
        "No travel packages are available at the moment",
        "Travel packages feature isn't activated at the moment",
        "Please try another time. We have no travel packages at the moment",
        "Travel Packages is deactivated due to site maintenance"
    ],
    "incomplete passenger name record": [
        `In order to continue to payment, you must provide complete information for all  
        passengers. Also, for all infant passenger, 
        one adult passenger must be selected for each,
         as the person responsible for the infant. 
         You may click on the each passenger card in order to open their form`,
        `You must provide complete information for all  
        passengers. And, for each infant passenger, 
        an adult passenger must be chosen to be responsible for them. 
        You may click on the each passenger card in order to open their form`,
        `You cant continue, if passenger information is not completed. 
        And, each infant passenger must have an adult to fly with them. 
        Click on each passenger card will open their form`
    ],
    "checkout completed but user is not logged in": [
        `The booking has been confirmed by the airline!
        However it will not be added to your booking history
        since you are not logged in..`,
        `Please login so that this booking can be associated 
        with your user account, or click on the 
        "Continue without logging in button" to continue
        `,
        `When you login, you ensure that your bookings are added to 
        your user account's booking history for you to easily retreive later...
        `
    ],
    "no language support": [
        "Lanuguage support has been disabled for maintenance purposes",
        "No language support for now",
        "Only English language can be used for now",
        "IT department is working to re-enabling language support",
    ],
    "no currency support": [
        "Currency support has been disabled for maintenance purposes",
        "No currency support for now",
        "Only US Dollar currency can be used for now",
        "IT department is working to re-enable currency support"
    ],
    "click to start flight booking": [
        "Click here to book flight...",
        "To book flight click here.",
        "Hello, Click here..",
        "Click here...",
        "Click for flights...",
        "Click here to start...",
        "Hey, Click here...",
        "To Start, Click here..."
    ],
    "wait while loading": [
        "We are working on it. Please wait!",
        "Fetching the data to you. Please wait!",
        "Please wait while the page loads.",
        "We are working on it. Wait, Please!",
        "We will get you there shortly.",
        "Please be patient while we work on it."
    ]
}